module.exports = __webpack_public_path__ + "img/SES_192422556.e01262e8.jpg";